import { ImageContent, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import ItemEditor from "./ItemEditor" 

/* Protopia Ecosystem component */
export interface IPassageItemEditFormProps {
   i:number
   primitive: ImageContent | any
   children: JSX.Element
   items: any[]
}
const CardEditForm = (props: IPassageItemEditFormProps): JSX.Element => {
   const isEdit: boolean = useLandingStore((state: ILandingStore) => state.isEdit )
   return isEdit
      ?
      <>
         { props.children }
         <ItemEditor 
            i={props.i} 
            item={props.primitive} 
            type={LANDING_TYPE_CONTENT.CARDS} 
            cards={props.items} 
         />
      </>
      :
      <>{props.children}</>
}
export default CardEditForm